import RightChartColumn from './BackTest/RightChartColumn'
import LeftChartColumn from './BackTest/LeftChartColumn'
import './BackTestV2.scss'
import { useSelector } from 'react-redux'
import EmptyData from 'components/common/EmptyData'

export default function BackTestV2() {
  const AnalysisStore = useSelector((state: any) => state?.AnalysisStore)
  
  return (
    <>
      <div className='cmQZzMRLKx'>
        {
          AnalysisStore?.backtest?.detailBacktest?.ticker ? <div className='pEuGCEkRbu'>
            <LeftChartColumn />
            <RightChartColumn />
          </div> : <div className='hhkxqbergc'>
            <EmptyData />
          </div>
        }
      </div>
    </>
  )
}